import React from 'react';

interface IKeys {
    enter?: (event: React.KeyboardEvent, data: any) => void;
    esc?: (event: React.KeyboardEvent, data: any) => void;
    space?: (event: React.KeyboardEvent, data: any) => void;
    left?: (event: React.KeyboardEvent, data: any) => void;
    up?: (event: React.KeyboardEvent, data: any) => void;
    right?: (event: React.KeyboardEvent, data: any) => void;
    down?: (event: React.KeyboardEvent, data: any) => void;
    backspace?: (event: React.KeyboardEvent, data: any) => void;
}

export default class KeyboardHandler {
    keys: IKeys = {};

    addHandlers(keys: IKeys) {
        this.keys = { ...this.keys, ...keys };
    }

    onKeyHandled = (key: string, event: React.KeyboardEvent, data?: any, shouldPreventDefault?: boolean) => {
        if (this.keys[key]) {
            shouldPreventDefault && event.preventDefault();
            this.keys[key](event, data);
        }
    };

    onPress = (event: React.KeyboardEvent, data?: any) => {
        switch (event.keyCode || event.charCode) {
            case 13: // Enter
                this.onKeyHandled('enter', event, data, true);
                break;

            case 27: // Escape
                this.onKeyHandled('esc', event, data, true);
                break;

            case 32: // Space
                this.onKeyHandled('space', event, data, true);
                break;

            case 37: // Left
                this.onKeyHandled('left', event, data, true);
                break;

            case 38: // Up
                this.onKeyHandled('up', event, data, true);
                break;

            case 39: // Right
                this.onKeyHandled('right', event, data, true);
                break;

            case 40: // Down
                this.onKeyHandled('down', event, data, true);
                break;

            case 8: // Backspace
                this.onKeyHandled('backspace', event, data);
                break;

            default:
                break;
        }
    };
}
